module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/vi_5-74d92090bbe43a437c8e530a0d5938ec.jpg";